import script from "./FinalistCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FinalistCard.vue?vue&type=script&setup=true&lang=js"

import "./FinalistCard.vue?vue&type=style&index=0&id=f9d18f2c&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9d18f2c"]])

export default __exports__